import { Header, SectionWrapper } from 'components/common/heap';
import { Row, Col, Grid } from 'react-flexbox-grid';
import { useIntl } from 'react-intl';
import requireValue from 'utils/requireValue';
import EnergyAndCO2Balance from './CalculationTables/EnergyAndCO2BalanceTable';
import AllCalculations from './CalculationTables/AllCalculations';
import EnergyClassesAndIndicatorsSection from './EnergyClassesAndIndicators';
import EnergyReductionAndGhgEquivalents from './EnergyReductionAndGhgEquivalents';
import type { TCO2Calculations } from './types';

interface ICO2CalculatorResultProps {
  co2Calculations: TCO2Calculations | null | undefined;
  nextStep?: () => void;
  previousStep?: () => void;
}

const CO2CalculatorResult = ({
  co2Calculations: co2CalculationsOrNull,
  nextStep,
  previousStep,
}: ICO2CalculatorResultProps) => {
  const { formatMessage: t } = useIntl();
  // Without calculations the sections crashed reading `co2Calculations.co2_emissions_before`.
  const co2Calculations = requireValue(co2CalculationsOrNull, 'co2_emissions_before');

  return (
    <Grid>
      <Row between="md">
        <Col md={12}>
          <Header>
            <h3>{t({ id: 'renovation_house_wizard.house_energy_balance.header' })}</h3>
          </Header>

          <EnergyClassesAndIndicatorsSection {...{ t, co2Calculations, nextStep }} />

          <Header>
            <h3>{t({ id: 'renovation_house_wizard.potential_energy_balance.title' })}</h3>
            <small className="muted">
              {t({ id: 'renovation_house_wizard.potential_energy_balance.description' })}
            </small>
          </Header>

          <EnergyReductionAndGhgEquivalents {...{ t, co2Calculations, nextStep, previousStep }} />

          <SectionWrapper>
            <EnergyAndCO2Balance {...{ co2Calculations }} />
          </SectionWrapper>
          <AllCalculations {...{ co2Calculations }} />
        </Col>
      </Row>
    </Grid>
  );
};

export default CO2CalculatorResult;
